import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row align-items-start" }
const _hoisted_2 = {
  key: 0,
  class: "col-lg-4 mb-25"
}
const _hoisted_3 = { class: "card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 stats-box" }
const _hoisted_5 = { class: "stats-grid" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_8 = { class: "fw-black mb-8 lh-1" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_11 = { class: "fw-black mb-8 lh-1" }
const _hoisted_12 = { class: "mt-3 d-flex flex-column align-items-start justify-content-end mt-auto gap-2" }
const _hoisted_13 = {
  type: "button",
  class: "card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block"
}
const _hoisted_14 = {
  type: "button",
  class: "card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block"
}
const _hoisted_15 = {
  key: 1,
  class: "col-lg-4 mb-25"
}
const _hoisted_16 = { class: "card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_17 = { class: "card-body p-15 p-sm-20 p-md-25 stats-box" }
const _hoisted_18 = { class: "title mb-3" }
const _hoisted_19 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_20 = { class: "fw-black mb-8 lh-1" }
const _hoisted_21 = { class: "stats-grid" }
const _hoisted_22 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_23 = { class: "fw-black mb-8 lh-1" }
const _hoisted_24 = {
  key: 2,
  class: "col-lg-4 mb-25"
}
const _hoisted_25 = { class: "card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_26 = { class: "card-body p-15 p-sm-20 p-md-25 stats-box" }
const _hoisted_27 = { class: "stats-grid" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_30 = { class: "fw-black mb-8 lh-1" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_33 = { class: "fw-black mb-8 lh-1" }
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_36 = { class: "fw-black mb-8 lh-1" }
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_39 = { class: "fw-black mb-8 lh-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.show_centers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createCommentVNode(" <div class=\"d-flex flex-column gap-3\"> "),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('feature.home.$stats.centers_count')), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.stats?.centers_count ?? '-'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('feature.home.$stats.countries_count')), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.stats?.countries_count ?? '-'), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_router_link, { to: { path: `/system-centers` } }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$t("page.centers")), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_router_link, { to: { path: `/create-center` } }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_14, _toDisplayString(_ctx.$t("cta.create_center")), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.show_users)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('feature.home.$stats.total_hcps')), 1 /* TEXT */),
                _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.total_hcps ?? '-'), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats?.users_count, (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "title",
                    key: user.role_id
                  }, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(user.role_name), 1 /* TEXT */),
                    _createElementVNode("h4", _hoisted_23, _toDisplayString(user.count ?? '-'), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createCommentVNode(" <div class=\"mt-3 d-flex flex-column align-items-start justify-content-end mt-auto gap-2\">\n                        <router-link :to=\"{ path: `/create-user` }\">\n                            <button type=\"button\"\n                                class=\"card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block\">\n                                {{ $t(\"cta.create_user\") }}\n                            </button>\n                        </router-link>\n                    </div> ")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.show_patients)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('feature.home.$stats.patients_invited_count')), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_30, _toDisplayString(_ctx.stats?.patients_invited_count ?? '-'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('feature.home.$stats.cargivers_count')), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_33, _toDisplayString(_ctx.stats?.cargivers_count ?? '-'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('feature.home.$stats.patients_activated_count')), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.stats?.patients_activated_count ?? '-'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('feature.home.$stats.therapies_started_count')), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_39, _toDisplayString(_ctx.therapies_started_count ?? '-'), 1 /* TEXT */)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" <div class=\"col-sm-6 col-md-6 col-lg-4 mb-25\" v-if=\"centers\">\n            <div class=\"card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0\">\n                <div class=\"card-body p-15 p-sm-20 p-md-25 stats-box\">\n                    <div class=\"d-flex flex-column gap-3\">\n                        <div class=\"title\" v-for=\"(value, key) in centers\" :key=\"key\">\n                            <span class=\"d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis\">{{\n                                $t(`feature.home.$stats.${key}`) }}</span>\n                            <h4 class=\"fw-black mb-8 lh-1\">{{ value ?? '-' }}</h4>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-sm-6 col-md-6 col-lg-4 mb-25\" v-if=\"users\">\n            <div class=\"card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0\">\n                <div class=\"card-body p-15 p-sm-20 p-md-25 stats-box\">\n                    <div class=\"d-flex flex-column gap-3\">\n                        <div class=\"title\" v-for=\"user in users.users_count\" :key=\"user.role_id\"><span\n                                class=\"d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis\">{{\n                                    user.role_name }}</span>\n                            <h4 class=\"fw-black mb-8 lh-1\">{{ user.count ?? '-' }}</h4>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> ")
  ]))
}